module.exports = __webpack_public_path__ + "img/logo-dark.bd447efd.svg";